import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import get from 'lodash.get';
import { NUMBER_1 } from '~shared/constants';
import { Category } from '~app/modules/generic/models';

export class GaTrackingViewPromotionEventModel {

  constructor(private products: Product[],
              private creative_name?: string,
              private item_list_name?: string,
              private priceType?: PriceTypes) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewPromotion;
  }

  getPayload(): GATrackingEventPayload {

    const productPromoViewTracking = {
      ecommerce: {
        item_list_name: this.item_list_name,
       creative_name: this.creative_name,
        items: this.products.map((product: Product, index: number) => {
          const categoriesList: Category[] = [...product?.categories].reverse() as any;

          return {
            item_name: product?.name,
            item_id: product?.id,
            item_discount_rate: product?.bestOffer?.referencePrice?.discountPercentage,
            item_brand: product?.attributes?.brand?.name,
            ...(categoriesList.reduce((categories: {}, category: Category, categoryIndex: number) => {
              if (categoryIndex === 0) {
                categories['item_category'] = category?.name;
              } else {
                categories[`item_category${categoryIndex + 1}`] = category.name;
              }

              return categories;
            }, {}) as any),
            index: index + NUMBER_1,
            quantity: NUMBER_1,
            price:
              this.priceType === 'entrepreneur'
                ? get(product, 'bestOffer.price.netPrice', 0)
                : get(product, 'bestOffer.price.grossPrice', 0),
          };
        })
      }
    };

    return {
      event: GaTrackingEventName.ViewPromotion,
      gtmCustom: productPromoViewTracking
    };
  }
}
